import jwtSessionService from '@app/services/jwtSessionService'
import authReturnUrlService from '@app/services/authReturnUrlService'

import { AxiosError } from 'axios'
import { ErrorResponseDto } from '@app/api/dtos'

import { responseStatus } from '@app/constants/responseStatus'

import type { AxiosInstance } from 'axios'

const handleAccessTokenRejected = async (error: AxiosError<ErrorResponseDto>): Promise<AxiosError> => {
  const status = error.response?.status

  if (status !== responseStatus.UNAUTHORIZED) throw error

  authReturnUrlService.setReturnUrl(window.location.pathname + window.location.search)
  jwtSessionService.clearSession()

  throw error
}

const applyUnauthorized = (api: AxiosInstance): void => {
  api.interceptors.response.use(response => response, handleAccessTokenRejected)
}

export default applyUnauthorized
